module.exports = __webpack_public_path__ + "static/img/access-profile.3ae61b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/browser-extension/access-profile.jpg
// module id = b55N
// module chunks = 1